import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: theme.spacing(150),
    maxWidth: '100%',
    height: '85vh',
    color: 'initial',

    '& .content': {
      padding: 0,
    },

    '& .iframe-help': {
      width: '100%',
      height: '100%',
      border: 'none',
    },

    '& .close-button': {
      color: theme.palette.primary.main,
    },

    [theme.breakpoints.up('md')]: {
      ...theme.globalStyles.scrollbar(theme),
    },
  },
}));

export default styles;
